import React, { Component } from 'react';
import { reduxForm, Field, FieldArray } from 'redux-form';
import { Form, Alert, Button, Row, Col } from 'antd';
import AntIcon from '../../shared/components/AntIcon';
import { Link } from 'react-router-dom';

import {
  formItemLayout,
  renderInput
} from '../../shared/utils/form_components';
import { required } from '../../shared/utils/form_validations';
import ImageFields from './ImageFields';

class CatalogForm extends Component {

  render() {
    const { handleSubmit, deleteError, error, submitting, deleteButton } = this.props;
    const err = deleteError || error;

    return (
      <Form layout="horizontal" onSubmit={handleSubmit}>

        <Row>
          <Col lg={18} xs={24}>

            <Form.Item>
              <Row gutter={[8, 8]} type="flex" justify="end" className="page-form-actions">
                <Col>
                  <Button>
                    <Link to="/catalog">Cancel</Link>
                  </Button>
                </Col>
                <Col>{deleteButton}</Col>
                <Col>
                  <Button
                    disabled={submitting} loading={submitting}
                    type="primary" htmlType="submit"
                  >
                    <AntIcon type="save" />Save
                  </Button>
                </Col>
              </Row>
            </Form.Item>

            {err && <Form.Item><Alert message={err} type="error" /></Form.Item>}

            <Form.Item
              {...formItemLayout}
              label="Name"
              required
            >
              <Row gutter={8}>
                <Col span={14}>
                  <Field
                    inputOnly
                    name="name"
                    placeholder="Name"
                    component={renderInput}
                    validate={required}
                  />
                </Col>
                <Col span={10}>
                  <Field
                    name="date"
                    placeholder="2017"
                    label="Date"
                    required
                    component={renderInput}
                    validate={required}
                  />
                </Col>
              </Row>
            </Form.Item>

          </Col>
        </Row>
        
        <FieldArray
          name="images"
          label="Image Urls"
          component={ImageFields}
        />

      </Form>
    );
  }
}

const validate = ({ name, date, description, images }) => {
  const errors = {};
  if (name && date && description && (!images || !images.length)) {
    errors._error = "Please add at least one image.";
  }
  return errors;
}

export default reduxForm({
  validate,
  form: 'CatalogForm',
})(CatalogForm);
